import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=4d948acf&scoped=true&"
import script from "./TeamList.vue?vue&type=script&lang=js&"
export * from "./TeamList.vue?vue&type=script&lang=js&"
import style0 from "./TeamList.vue?vue&type=style&index=0&id=4d948acf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d948acf",
  null
  
)

export default component.exports